module.exports = __webpack_public_path__ + "img/55.de038483.png";